module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading full-character-formatting",
    attrs: {
      "epub:type": "chapter",
      "id": "part-1-unnumbered-1",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("0700 Hours: Into the Light")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "part-1-unnumbered-1-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("“Jon, I’m pregnant.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Whatever effect Marianna Bonaventure might have anticipated this announcement having, it had not included the little convertible being braked hard enough to trigger the automatic seatbelt locks.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("One moment, she and Jonathan Knox had been cruising up the stretch of El Camino Real that ran through the wilds of Big Sur, California. The next, they were sitting on the shoulder, engine ticking, clouds of road dust rising around them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jon was staring at her intently from the driver’s seat, silently studying her face.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Marianna’s heart sank. "), _c('i', [_vm._v("Oh, God. He thinks I’m trying to trap him!")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“No worries.” She affected a nonchalance she didn’t really feel. “I’ll be fine—”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jon leaned over and kissed her on the lips.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“No,” he said. “"), _c('i', [_vm._v("We’ll")]), _vm._v(" be fine.”")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("Marianna Knox née Bonaventure smiled at the memory, then winced.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Soon now. Her night-long labor was entering its final throes as the first rays of dawn spilled across the birthing bed. Jon stood beside her in the delivery room, holding her hand. She could tell by his abstracted look that he was trying to recall the finer points of his Lamaze training. Typical male: he was having enough trouble remembering to breathe himself, much less urge her to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("To Marianna, the intervals between contractions felt like floating becalmed in the gentle swells of a tranquil sea. Then without warning a storm surge of agony would hoist her up, up into the sky, rip through her, and tumble her over and over. It crested and, as quickly as it had come, it was gone. Then she was sliding down the long, liquid"), _c('i'), _vm._v("slope into the trough, gasping for breath and bracing for the next wave.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her uterus pulsed like a metronome—a metronome whose rhythm was accelerating, beats coming faster and faster—nature’s countdown.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But in between the beats came moments of introspection, thoughts about what it all meant. According to all the mother-to-be self-helps she’d read, she was about to embark upon the “adventure of a lifetime.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Well, maybe so. But considering all the adventures in Marianna’s lifetime to date, there would be some stiff competition for that accolade.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She smiled again, then frowned, recalling a summer evening she and Jon had spent together two years back, cruising the North Atlantic onboard a corporate megayacht as big as a city block. All while, in the depths below them, a secret installation ensconced in the summit of an undersea mountain ticked down the final hours till Armageddon.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The memory whirled away into darkness as another contraction crashed into her, this one feeling for all the world as if a giant’s hand gripped her innards and squeezed them, trying to push them down, down, and out of her body cavity altogether.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Then it passed, leaving her drifting among reminiscences once again.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Reminiscences of a night in a futuristically palatial compound overlooking the Pacific, the scene of a technology launch gone horribly, earth-shatteringly awry, threatening to merge all the world’s intellects into a single, mindless meta-consciousness, and of a last-second intervention from an unexpected quarter.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Reminiscences segueing into that long walk up the aisle on the arm of her boss, Euripides “Pete” Aristos who stood in for her late father. She walked toward a beaming Jon, accompanied by his unlikely best man, Finley “Mycroft” Laurence, who seemed determined to make up for the groom’s evident lack of nervousness with a double helping of his usual agoraphobia.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And then the contractions were upon her again.")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("In the two and a half years they’d been together, Jonathan Knox had watched while Marianna poleaxed a hulking Gruzian hitman, had gazed through someone else’s eyes as she consigned an Iranian terrorist to a hell of his own devising, preventing gigadeaths in the process. Both times.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But this—this was far and away the bravest thing he had ever seen her do.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Yet, as proud as he was of his partner—his new wife, the soon-to-be mother of their child—Knox also felt … helpless, useless, superfluous. Not for the first time, he wondered what in the hell he was supposed to be doing here. Providing back rubs and foot massages? Timing contractions? Helping allay anxieties?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As far as that last part was concerned, he might as well forget about it. If anything, Knox was more anxious even than Marianna herself.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Jon?” Marianna’s whisper intruded upon his self-indulgent funk. “Could I have a sip of water, please?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Knox inserted a straw in the water bottle and brought it to her lips. Holding the bottle in position with one hand, he sponged Marianna’s forehead with the other.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You’re doing fine, "), _c('i', [_vm._v("solnyshka")]), _vm._v(".” He used the Russian word for “sunshine,” the term of endearment not only evoking the brightening dawn, but also serving as a reminder of the assignment that had first brought them together. “Just a little bit longer now.”")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("“Just a little bit longer now” would also have been the thought entertained by the insubstantial instrumentalities currently traversing near-Earth space. Had they been capable of thought.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("As matters stood, all that these rudimentary ripples of trimeric light could manage was to receive a feed from the Washington Square relay station and retransmit it to the wavefront’s central processing locus out past the orbit of Saturn. That feed, in turn, contained, suitably amplified, the feeble emanations from the monitors in the delivery room at Saint Bartholomew where Marianna Knox lay giving birth.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The photonic entity that was called “the Emissary” by its human servants received that feed. Only then it could fully formulate the thought:")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Just a little bit longer now, and the Transfiguration can begin.”")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-563"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/break-rule-gradient-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("With a final, shuddering convulsion, Marianna delivered. It was a little girl, whom she and Jon had agreed to name Persephone. Exhausted as she was, Marianna had to smile: it had taken some persuading to get Jon on board with the mythological reference.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Persephone?” had been his initial response when she’d broached it to him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Mom and Dad would’ve loved it.” They would have, too. Marianna’s deceased parents were both students of Greek antiquity. “Why? What’s wrong with Persephone?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“It’s just that—well, what are the other kids going to call her?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“That’s the whole point: Persephone is nickname proof. I never liked nicknames.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But Jon was thinking out loud now. “Persey. Persey Knox. Has kind of a ring to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Marianna found herself wishing her mother could be here to see this, to see what she and Jon had made. Because Persephone was perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Nine pounds, two ounces,” the assistant was calling out. “Twenty-one and a half inches long.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("Going to be a ")]), _vm._v("tall"), _c('i', [_vm._v(" girl!")]), _vm._v(" The right number of fingers and toes, and …")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("What had gone wrong with the light? The early morning sunbeams now streaming down through the skylight seemed … "), _c('i', [_vm._v("off")]), _vm._v(" somehow. Dimming, though there wasn’t a cloud in the sky. Then brightening again, but now with a bluish tinge, which quickly cycled through all the colors of the rainbow, looking like light filtered through stained glass. And, caught in the sunbeams, bathed in the unearthly radiance, Persephone nestled peacefully in a nurse’s arms.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Too peacefully. "), _c('i', [_vm._v("Why isn’t she crying?")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And why was the doctor monitoring the DNA microarray looking so worried all of a sudden?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e57cf408","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part001chapter0700hoursintothelight.vue
// module id = 81
// module chunks = 0